import React from 'react';
import { generalMedia } from '../../data/generalMedia';

export function WelcomeSection() {
  const img = generalMedia['welcome-section-about'];
  return (
    <section className="py-12 px-4 bg-transparent">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-8">
        {/* Text & Button */}
        <div className="w-full md:w-1/2 text-center md:text-left">
          <h2 className="text-3xl md:text-4xl font-semibold text-slate-700 mb-4">
            Welcome to Great Child
          </h2>
          <a
            href="/about"
            className="inline-block bg-purple-800 text-white uppercase text-sm font-medium tracking-wide px-6 py-3 rounded-full hover:bg-purple-700 transition"
          >
            About Great Child
          </a>
        </div>

        {/* Image */}
        <div className="w-full md:w-1/2">
          <a href="/about" aria-label="About Great Child">
            <img
              src={img.src}
              alt={img.alt}
              width={1440}
              height={1440}
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
              loading="lazy"
              decoding="async"
              fetchPriority="low"
            />
          </a>
        </div>
      </div>
    </section>
  );
}
